import axios from "../../config/axiosConfig";
import {
  ITEM_LEDGER_REPORT_REQUEST,
  ITEM_LEDGER_REPORT_SUCCESS,
  ITEM_LEDGER_REPORT_FAILURE,
  ITEM_LEDGER_FILTER_REPORT_REQUEST,
  ITEM_LEDGER_FILTER_REPORT_SUCCESS,
  ITEM_LEDGER_FILTER_REPORT_FAILURE,
  ITEM_LEDGER_TRANSACTIONS_REQUEST,
  ITEM_LEDGER_TRANSACTIONS_SUCCESS,
  ITEM_LEDGER_TRANSACTIONS_FAILURE,
  ITEM_LEDGER_MONTH_TRANSACTIONS_REQUEST,
  ITEM_LEDGER_MONTH_TRANSACTIONS_SUCCESS,
  ITEM_LEDGER_MONTH_TRANSACTIONS_FAILURE,
  CLEAR_ITEM_LEDGER_TRANSACTIONS
} from "../types/item-ledger-report-types";

export const getItemLedger = (params) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: ITEM_LEDGER_REPORT_REQUEST });

      const { auth } = getState();

      const defaultParams = {
          finyearId: auth.finyear?.id,
          ...(params?.commonMaster ? {} : { companyId: auth.company?.id }),
          customerId: auth.user?.Customer_Id,
          companyIdForGeneralSetting: auth.company?.id,
      };

      const defaultParams2 = {
        filterType: params?.filterType,
        fromDate: params?.fromDate, 
        toDate: params?.toDate, 
        ...params
      };
      // Merge default params with provided params
      const requestParams = { ...defaultParams, ...defaultParams2 };

      // Log the request parameters
      console.log('Request Param Datas >>>>>', requestParams);

      // Construct the complete URL with query parameters
      const queryString = new URLSearchParams(requestParams).toString();
      const fullUrl = `/stock-report/getItemLedger?${queryString}`;

      // Log the full URL (to debug)
      console.log('>>Complete API Request URL: ', fullUrl);

      // Make API call
      return axios.get(fullUrl).then((response) => {
        console.log('>>>API Response Data: ', response);
        // Dispatch success action with data
        if (response.data) {
          dispatch({ type: ITEM_LEDGER_REPORT_SUCCESS, payload: response.data });
        }
      }).catch((error) => {
        console.error("Error fetching item ledger Report:", error);
        dispatch({ type: ITEM_LEDGER_REPORT_FAILURE, error: error.message });
      });
    } catch (error) {
      console.error("Error fetching item ledger Report:", error);
      dispatch({ type: ITEM_LEDGER_REPORT_FAILURE, error: error.message });
    }
  };
};

export const getItemLedgerTransactions = (extraParams) => {
  return async (dispatch, getState) => {
    try {
      if((extraParams?.monthWiseReq === true || extraParams?.monthWiseReq === 'true') && !extraParams?.month){
        dispatch({ type: ITEM_LEDGER_MONTH_TRANSACTIONS_REQUEST });
      } else {
        dispatch({ type: ITEM_LEDGER_TRANSACTIONS_REQUEST });
      }
      
      const { auth } = getState();
      const params = {
        ...extraParams,
        finyearId: auth.finyear?.id,
        ...(extraParams?.commonMaster ? {} : { companyId: auth.company?.id }),
        companyIdForGeneralSetting: auth.company?.id,
        customerId: auth.user?.Customer_Id
      };

      const queryString = new URLSearchParams(params).toString();
      const fullUrl = `/stock-report/getItemLedgerTransactions?${queryString}`;
      
      console.log('Fetching transactions with URL:', fullUrl);

      const response = await axios.get(fullUrl);
      
      if (response.data) {
        if((extraParams?.monthWiseReq === true || extraParams?.monthWiseReq === 'true') && !extraParams?.month){
          dispatch({ 
            type: ITEM_LEDGER_MONTH_TRANSACTIONS_SUCCESS, 
            payload: Array.isArray(response.data) ? response.data : [] 
          });
          return response.data;
        } else {
          dispatch({ 
            type: ITEM_LEDGER_TRANSACTIONS_SUCCESS, 
            payload: Array.isArray(response.data) ? response.data : [] 
          });
          return response.data;
        }
      }
      return [];
    } catch (error) {
      console.error("Error fetching item ledger transactions:", error);
      if((extraParams?.monthWiseReq === true || extraParams?.monthWiseReq === 'true') && !extraParams?.month){
        dispatch({ 
          type: ITEM_LEDGER_MONTH_TRANSACTIONS_FAILURE, 
          error: error.message 
        });
      } else {
        dispatch({ 
          type: ITEM_LEDGER_TRANSACTIONS_FAILURE, 
          error: error.message 
        });
      }
      throw error;
    }
  };
};

export const clearItemLedgerTransactions = () => {
  return async (dispatch) => {
      dispatch({ type: CLEAR_ITEM_LEDGER_TRANSACTIONS });
  }
};

export const getItemLedgerFilterDetail = (params) => {
    return async (dispatch, getState) => {
        try {
            dispatch({ type: ITEM_LEDGER_FILTER_REPORT_REQUEST });

            const { auth } = getState();
            
            const defaultParams = {
                finyearId: auth.finyear?.id,
                ...(auth.company?.Common_Master ? {} : { companyId: auth.company?.id }),
                customerId: auth.user?.Customer_Id,
            };
            
            const requestParams = { ...defaultParams };

            const queryString = new URLSearchParams(requestParams).toString();
            const fullUrl = `/stock-report/getItemLedgerFilterDetail?${queryString}`;

            console.log('<<Complete API Request URL: ', fullUrl);

            return axios.get(fullUrl).then((response) => {
                console.log('API Response Data: ', response);
                if (response.data) {
                dispatch({ type: ITEM_LEDGER_FILTER_REPORT_SUCCESS, payload: response.data });
                }
            }).catch((error) => {
                console.error("Error fetching item ledger Report:", error);
                dispatch({ type: ITEM_LEDGER_FILTER_REPORT_FAILURE, error: error.message });
            });
        } catch (error) {
            console.error("Error fetching item ledger Report:", error);
            dispatch({ type: ITEM_LEDGER_FILTER_REPORT_FAILURE, error: error.message });
        }
    };
};


